export const LOAD_WIDGET_SETTINGS = 'LOAD_WIDGET_SETTINGS';